import { useMemo, useState } from 'react'
import type { FC, PropsWithChildren } from 'react'

import { SearchContext } from './useSearchContext'

/**
 * Provider component that manages search focus state
 * Used to control overlay background when search is focused
 */
export const SearchProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isSearchFocused, setIsSearchFocused] = useState(false)

  const value = useMemo(
    () => ({
      isSearchFocused,
      setIsSearchFocused,
    }),
    [isSearchFocused],
  )

  return <SearchContext value={value}>{children}</SearchContext>
}
